import Inputmask from 'inputmask';

export function useAppendMask($element: HTMLInputElement): void {
	const mask: string = $element.dataset.mask;

	switch (mask) {
		case 'date':
			Inputmask('datetime', {
				placeholder: '__.__.____',
				inputFormat: 'dd.mm.yyyy',
			}).mask($element);
			break;

		case 'datetime':
			Inputmask('datetime', {
				placeholder: '__.__.____ __:__',
				inputFormat: 'dd.mm.yyyy HH:MM',
			}).mask($element);
			break;

		case 'tel':
			Inputmask({
				mask: '+7 (999) 999-99-99',
			}).mask($element);
			break;

		case 'tax':
			Inputmask({
				placeholder: '',
				mask: '9{10,12}',
			}).mask($element);
			break;

		case 'digits':
			Inputmask({
				placeholder: '',
				mask: '9{1,50}',
				showMaskOnHover: false,
			}).mask($element);
			break;

		default:
			Inputmask({
				mask: mask,
			}).mask($element);
			break;
	}
}
